export default 'M6 14.5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5m18-4.25H11.74a6 6 0 1 0 0 3.5H18V17h4v-3.25h2z';